import Vue from 'vue'

const timeSheet = {
  state: {
    timeSheet: [],
    selectedTimeSheet: {},
  },

  getters: {
    timeSheet(state) {
      return state.timeSheet
    },
    selectedTimeSheet(state) {
      return state.selectedTimeSheet
    },
  },

  mutations: {
    timeSheet(state, payload) {
      state.timeSheet = payload
    },
    selectedTimeSheet(state, payload) {
      state.selectedTimeSheet = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedTimeSheet(context, payload) {
      context.commit('selectedTimeSheet', payload)
    },
    loadTimeSheet(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'TimeSheet'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('timeSheet', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedTimeSheet(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'TimeSheet/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedTimeSheet', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateTimeSheet(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TimeSheet/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'timesheet updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTimeSheet')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createTimeSheet(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TimeSheet`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'timesheet created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTimeSheet')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveTimeSheet(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateTimeSheet', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createTimeSheet', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteTimeSheet(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TimeSheet/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'timesheet deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTimeSheet')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default timeSheet
